










































































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import { URL_EMAIL_SERVICE as URL } from "../constants";
import VueRouter, { Route } from "vue-router";
import { EventBus } from "../main";
import router from "../router";

@Component({
  name: "FormularioContato",

  components: {
    "vue-recaptcha": VueRecaptcha
  }
})
export default class FormularioContato extends Vue {
  mounted() {
    EventBus.$on("mudouRota", (next: any) => {
      this.faleConosco = {
        nome: this.nome,
        instituicao: this.instituicao,
        telefone: this.telefone,
        email: this.email,
        idAreaContato: this.select,
        assunto: this.assunto,
        mensagem: this.mensagem,
        gRecaptchaResponse: this.resposta
      };

      let campos: Array<any> = Object.values(this.faleConosco);

      campos.forEach(el => {
        if (el != null && el != "") {
          this.vazio = false;
          this.resetarFormularioDialogo = true;
        }
      });

      if (this.vazio) {
        next();
      }
    });
  }

  vazio: boolean = true;
  dialogTrabalhe: boolean = false;
  dialogTrabalheMD: boolean = false;
  nome: string = "";
  instituicao: string = "";
  telefone: any = "";
  email: string = "";
  select: any = null;
  assunto: string = "";
  mensagem: string = "";
  faleConosco: any = {};
  aberto: any = null;
  resposta: any = null;
  dialogo: boolean = false;
  resetarFormularioDialogo: boolean = false;
  erro: boolean = false;

  get form(): Vue & { validate: () => boolean; reset: () => boolean } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  get recaptcha(): Vue & { reset: () => boolean } {
    return this.$refs.recaptcha as Vue & { reset: () => boolean };
  }

  get isPequeno() {
    if (
      this.$vuetify.breakpoint.name == "xs" ||
      this.$vuetify.breakpoint.name == "sm"
    ) {
      return true;
    } else {
      return false;
    }
  }

  mostrar() {
    if (
      this.$vuetify.breakpoint.name == "xs" ||
      this.$vuetify.breakpoint.name == "sm"
    ) {
      this.aberto = !this.aberto;
    }
  }

  itemsArea: any = [
    { area: "Administrativo | Financeiro", id: 1 },
    { area: "Implantação e Suporte", id: 2 },
    { area: "Infraestrutura e Inovação", id: 3 },
    { area: "Marketing | Comercial", id: 4 },
    { area: "Qualidade | Ouvidoria", id: 5 },
    { area: "Diretoria", id: 6 }
  ];

  valido(recaptchaToken: any) {
    this.resposta = recaptchaToken;
  }

  async enviar() {
    try {
      if (!this.form.validate() || this.resposta == null) {
        this.erro = true;
        return;
      }

      this.faleConosco = {
        nome: this.nome,
        instituicao: this.instituicao,
        telefone: this.telefone,
        email: this.email,
        idAreaContato: this.select,
        assunto: this.assunto,
        mensagem: this.mensagem,
        gRecaptchaResponse: this.resposta
      };

      let result = await this.$http.post(URL + "ws/siteauge/contato/", {
        faleConosco: this.faleConosco
      });

      this.dialogo = true;
      this.erro = false;
      this.form.reset();
      this.recaptcha.reset();
      this.resposta = null;
    } catch (error) {
      // console.log(error);
    }
  }

  cancelarNavegacao() {
    this.vazio = true;
    this.resetarFormularioDialogo = false;
  }

  confirmarNavegacao() {
    this.resetarFormularioDialogo = false;
    this.vazio = true;
    this.form.reset();
    this.recaptcha.reset();
    this.resposta = null;
    this.erro = false;
    EventBus.$emit("navegar");
  }
}
